import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AssignementNotAcceptingListingModel } from 'common/models/page-models/Assignment Non Accepted Model/assignment-non-accepted-params.model';
import { AssignmentModel } from 'common/models/page-models/Assignments Model/assignment-data.model';

import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { AssigmentNotAcceptedGridWidgetService } from 'common/widget/assignment/assigment-not-accepting-grid-widget.service';


@Injectable({
    providedIn: 'root'
})
export class AssigmentNotAcceptedGridResolver extends GridResolver<AssignmentModel, AssignementNotAcceptingListingModel> {
    constructor(
        protected fs: AssigmentNotAcceptedGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);

    }


}
